import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {lastValueFrom} from 'rxjs';
import {ApiHelperService} from './api-helper.service';
import {CamOpGroup} from '../models/camop-group';
import {GenericAPIArrayResponse, GenericAPIResponse} from '../models/api-response';
import {ShooterInfo} from '../models/shooters';
import {TeamDirectoryEntry} from '../models/team-directory';

@Injectable({providedIn: 'root'})
export class CamOpGroupService {
  constructor(private http: HttpClient, private apiHelper: ApiHelperService) {}

  getGroups(): Promise<GenericAPIArrayResponse<CamOpGroup>> {
    return lastValueFrom(this.http.get<GenericAPIArrayResponse<CamOpGroup>>(`${this.apiHelper.apiUrl()}/camop-groups`, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  getMyGroup(): Promise<GenericAPIResponse<CamOpGroup>> {
    return lastValueFrom(this.http.get<GenericAPIResponse<CamOpGroup>>(`${this.apiHelper.apiUrl()}/camop-groups/me`, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  getTeamDirectory(teamid: string): Promise<GenericAPIArrayResponse<TeamDirectoryEntry>> {
    return lastValueFrom(this.http.get<GenericAPIArrayResponse<TeamDirectoryEntry>>(`${this.apiHelper.apiUrl()}/camop-groups/teams/${teamid}/directory`, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  getPayrollAccess(): Promise<GenericAPIResponse<{allowed: boolean}>> {
    return lastValueFrom(this.http.get<GenericAPIResponse<{allowed: boolean}>>(`${this.apiHelper.apiUrl()}/camop-groups/payroll-access`, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  createGroup(group: CamOpGroup): Promise<GenericAPIResponse<CamOpGroup>> {
    return lastValueFrom(this.http.post<GenericAPIResponse<CamOpGroup>>(`${this.apiHelper.apiUrl()}/camop-groups`, group, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  updateGroup(groupid: string, update: Partial<CamOpGroup>): Promise<GenericAPIResponse<CamOpGroup>> {
    return lastValueFrom(this.http.put<GenericAPIResponse<CamOpGroup>>(`${this.apiHelper.apiUrl()}/camop-groups/${groupid}`, {update}, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  deleteGroup(groupid: string): Promise<GenericAPIResponse<unknown>> {
    return lastValueFrom(this.http.delete<GenericAPIResponse<unknown>>(`${this.apiHelper.apiUrl()}/camop-groups/${groupid}`, {headers: this.apiHelper.apiHeaderWithToken()}));
  }

  transferShooter(userid: string, camopGroupId?: string): Promise<GenericAPIResponse<ShooterInfo>> {
    return lastValueFrom(this.http.put<GenericAPIResponse<ShooterInfo>>(`${this.apiHelper.apiUrl()}/camop-groups/shooters/${userid}`, {camopGroupId}, {headers: this.apiHelper.apiHeaderWithToken()}));
  }
}
